import { useMutation, useQueryClient } from '@tanstack/react-query';
import { detachUsersFromGroup } from '../services/security-groups';

export function useDetachUsersMutation(groupId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userIds: string[]) => detachUsersFromGroup(groupId, userIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'users'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });
}
